// 文章4数据信息
export default {
  id: 'dayunshan_104',
  content: `# 苦荞麦—糖尿病的克星
  ![1](https://cdn.keihong.tech/img/20250518212955505.jpg)
![2](https://cdn.keihong.tech/img/20250518212959959.jpg)
![3](https://cdn.keihong.tech/img/20250518213006389.jpg)
![3](https://cdn.keihong.tech/img/20250518213019418.jpg)
`
}
